import React, { useEffect, useState } from 'react';
import { TextField, Button, Paper, Typography, Stack, Chip, CircularProgress, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// TODO: Replace with actual API call
async function fetchLocationById(id: string) {
  // Simulate API call
  return {
    id,
    name: 'Cozy Baby Cafe',
    address: '123 Baby Lane, Babyville, 12345',
    latitude: 44.6488,
    longitude: -63.5752,
    type: 'cafe',
    phoneNumber: '+11234567890',
    websiteUrl: 'https://cozybabycafe.com',
    hoursOfOperation: 'Mon-Fri 9:00-17:00',
    isAccessible: true,
    isGenderNeutral: true,
    notes: 'Great for families!',
  };
}

// TODO: Replace with actual API call
async function updateLocation(id: string, data: any) {
  // Simulate API call
  return { success: true };
}

const LocationEditPage = ({ locationId }: { locationId?: string }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState<any>(null);

  useEffect(() => {
    if (!locationId) return;
    setLoading(true);
    fetchLocationById(locationId)
      .then((data) => {
        setForm(data);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load location');
        setLoading(false);
      });
  }, [locationId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleChipToggle = (field: string) => {
    setForm({ ...form, [field]: !form[field] });
  };

  const handleSubmit = async () => {
    setError(null);
    setSuccess(false);
    try {
      await updateLocation(locationId!, form);
      setSuccess(true);
      setTimeout(() => navigate(`/location/${locationId}`), 1200);
    } catch {
      setError('Failed to update location');
    }
  };

  if (loading) return <CircularProgress sx={{ mt: 4 }} />;
  if (!form) return null;

  return (
    <Paper sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Edit Location
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>Location updated!</Alert>}
      <Stack spacing={2}>
        <TextField label="Name" name="name" value={form.name} onChange={handleChange} fullWidth />
        <TextField label="Address" name="address" value={form.address} onChange={handleChange} fullWidth />
        <TextField label="Latitude" name="latitude" value={form.latitude} onChange={handleChange} fullWidth />
        <TextField label="Longitude" name="longitude" value={form.longitude} onChange={handleChange} fullWidth />
        <TextField label="Type" name="type" value={form.type} onChange={handleChange} fullWidth />
        <TextField label="Phone Number" name="phoneNumber" value={form.phoneNumber} onChange={handleChange} fullWidth />
        <TextField label="Website URL" name="websiteUrl" value={form.websiteUrl} onChange={handleChange} fullWidth />
        <TextField label="Hours of Operation" name="hoursOfOperation" value={form.hoursOfOperation} onChange={handleChange} fullWidth />
        <TextField label="Notes" name="notes" value={form.notes} onChange={handleChange} fullWidth multiline minRows={2} />
        <Stack direction="row" spacing={2}>
          <Chip
            label="♿ Accessible"
            color={form.isAccessible ? 'success' : 'default'}
            variant={form.isAccessible ? 'filled' : 'outlined'}
            onClick={() => handleChipToggle('isAccessible')}
          />
          <Chip
            label="🚻 Gender Neutral"
            color={form.isGenderNeutral ? 'info' : 'default'}
            variant={form.isGenderNeutral ? 'filled' : 'outlined'}
            onClick={() => handleChipToggle('isGenderNeutral')}
          />
        </Stack>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Stack>
    </Paper>
  );
};

export default LocationEditPage;
